import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import lang from '../../constants/Languages.js';
import { HashLink as Link } from 'react-router-hash-link';

const FooterSitemap = ({clang, list, user, logout}) => {
    return (
        <div className="footer__sitemap">
            <div className="footer__container">
                <h4 className="footer__sitemap__header">
                    {lang[clang].footer.sitemap}
                </h4>
                <ul className="footer__sitemap__list">
                    <li className="footer__sitemap__list-item">
                        <Link to={`/`} className="footer__sitemap__list__link" title={lang[clang].home}>
                            {lang[clang].home}
                        </Link>
                    </li>
                    {list && list.map((listItem, index) =>
                        <li key={index} className="footer__sitemap__list-item">
                            <Link to={`${listItem.url}`} className="footer__sitemap__list__link" title={listItem.title}>
                                {listItem.title}
                            </Link>
                            <ul className="footer__sitemap__list-item__children">
                                  {listItem.children && listItem.children.length && listItem.children.map((childItem, index) =>
                                      <li key={index}>
                                          <Link to={`${childItem.url}`}
                                          className="footer__sitemap__list-item__child-link"
                                          title={childItem.title}
                                          scroll={el => el.scrollIntoView({ block: 'start' })}>
                                              {childItem.title}
                                          </Link>
                                      </li>)}
                            </ul>
                        </li>)}
                    <li className="footer__sitemap__list-item">
                        <div>
                          <div className="footer__sitemap__list__box">
                              <div className="footer__sitemap__list__subheader">
                                  {lang[clang].footer.visit}
                              </div>
                              <div className="footer__social">
                                  <div className="footer__social-link">
                                      <span className="footer__social-img--fb"></span>
                                  </div>
                                  <a href="https://www.facebook.com/Polska.Bibliografia.Literacka" target="_blank" rel="noopener noreferrer"
                                  className="footer__sitemap__list-item__child-link"
                                  title={lang[clang].title.facebook}>
                                      {lang[clang].footer.fb}
                                  </a>
                              </div>
                          </div>
                          <div className="footer__sitemap__list__box">
                              <div className="footer__sitemap__list__subheader">
                                  {lang[clang].footer.admin}
                              </div>
                              <div className="footer__social">
                                  <div className="footer__social-link">
                                      <span className="footer__social-img--user"></span>
                                  </div>
                                  <a href="https://pbl2.dlibra.psnc.pl/login/" target="_blank" rel="noopener noreferrer" className="footer__sitemap__list-item__child-link" title={lang[clang].footer.admin}>
                                      {lang[clang].login}
                                  </a>
                              </div>
                          </div>
                          <div className="footer__sitemap__list__box">
                              <div className="footer__sitemap__list__subheader">
                                  {lang[clang].footer.login}
                              </div>
                              <div className="footer__login">
                                  <div className="footer__social-link">
                                      <span className="footer__social-img--user"></span>
                                  </div>
                                  {user && <p className="footer__login-hello">{lang[clang].login_hello}{user.firstName}!</p>}
                                  {!user && <Link to={'/login'} className="footer__sitemap__list-item__child-link" title={lang[clang].login}>
                                                {lang[clang].login}
                                            </Link>}
                                  {user && <button onClick={() => logout()} className="footer__login-logout" >
                                                {lang[clang].logout}
                                            </button>}
                              </div>
                          </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(FooterSitemap));



// WEBPACK FOOTER //
// ./src/components/footer/FooterSitemap.js